module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo2-2745917f01f932e283a36794ab133b1e.jpg";